import { LOCAL_STORAGE_USER_LOGIN_INFO } from "@app/constants/Common";
import { MaxStepCddEmpProcessOptions } from "@pages/dvtjcuv/common/Constant";
import { pipelineOptionsToString, pipelineStringToOptions } from "@pages/jobpipeline/common/PipelineUtil";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Select from "react-select";

export const SearchRangeFields = [
    'from_number_brief_uv_sent',
    'to_number_brief_uv_sent',
    'from_number_cv_sent',
    'to_number_cv_sent',
    'from_number_job',
    'to_number_job',
    'from_number_interview',
    'to_number_interview',
    'from_number_offer',
    'to_number_offer',
];

const SearchPipelineRangeModal = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep({}));
    const [searching, setSearching] = useState(false);
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {isShow, mode, searchInput, onClose, onSearch} = props

    const onSearchClick = () => {
        onSearch(pipelineOptionsToString(searchConditions))
    }

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(() => {
        console.log("Advance Search input:" + JSON.stringify(searchInput))
        if (searchInput) {
            setSearchConditions(pipelineStringToOptions(searchInput))
        } else {
            setSearchConditions({})
        }
    }, [searchInput]);

    const onClearSearchCondition = () => {
        // const fields = Object.keys(searchConditions)
        SearchRangeFields.forEach(f => {
            searchConditions[f] = ''
        })
        setSearchConditions({...searchConditions})
    }

    const onChangeInput = (event, field) => {
        if (field === 'max_step') {
            searchConditions.max_step = event;
        } else {
            searchConditions[event.target.name] = event.target.value;
        }
        setSearchConditions({...searchConditions});
    };
    
    const showField = (label, key, onChange) => {
        let displayLabel = label;
        if (mode === 'search-receiver') {
            if (key === 'from_number_brief_uv_sent') {
                displayLabel = 'Số Brief UV received from';
            } else if (key === 'to_number_brief_uv_sent') {
                displayLabel = 'Số Brief UV received to';
            } else if (key === 'from_number_cv_sent') {
                displayLabel = 'Số CV received from';
            } else if (key === 'to_number_cv_sent') {
                displayLabel = 'Số CV received to';
            }
        }
        
        return (
            <div className="col-sm-6">
                <div className="form-group">
                    <label className={'w-100'}>{displayLabel}</label>
                    <input
                        type="number"
                        className="form-control"
                        value={searchConditions[key]}
                        name={key}
                        onChange={(event) => onChange(event)}
                    />
                </div>
            </div>
        );
    };

    return (
        <>
            <Modal
                show={isShow}
                size={'xl'}
                onHide={() => onClose()}
                animation={false}
            >
                <Modal.Header>
                    <Modal.Title>Tìm kiếm dvtjcuv pipeline</Modal.Title>
                    <Button variant="secondary" onClick={() => onClose()}>
                        Close
                    </Button>
                </Modal.Header>
                <form onSubmit={onSearchClick}>
                <Modal.Body>
                    {mode === 'search-employer' && (
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label className={'w-100'}>Step cao nhất</label>
                                    <Select
                                        options={MaxStepCddEmpProcessOptions}
                                        placeholder={'Chọn step'}
                                        value={
                                            searchConditions.max_step
                                                ? searchConditions.max_step
                                                : ''
                                        }
                                        onChange={(value) => {
                                            onChangeInput(
                                                value,
                                                'max_step'
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    <div className={'row'}>
                        {showField("Số Brief UV sent from", "from_number_brief_uv_sent", onChangeInput)}
                        {showField("Số Brief UV sent to", "to_number_brief_uv_sent", onChangeInput)}
                    </div>
                    <div className={'row'}>
                        {showField("Số CV sent from", "from_number_cv_sent", onChangeInput)}
                        {showField("Số CV sent to", "to_number_cv_sent", onChangeInput)}
                    </div>
                    <div className={'row'}>
                        {showField("Số Job from", "from_number_job", onChangeInput)}
                        {showField("Số Job to", "to_number_job", onChangeInput)}
                    </div>
                    <div className={'row'}>
                        {showField("Số Interview from", "from_number_interview", onChangeInput)}
                        {showField("Số Interview to", "to_number_interview", onChangeInput)}
                    </div>
                    <div className={'row'}>
                        {showField("Số Offer from", "from_number_offer", onChangeInput)}
                        {showField("Số Offer to", "to_number_offer", onChangeInput)}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={() => onClearSearchCondition()}
                        disabled={searching}
                    >
                        {'Clear'}
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        // onClick={onSearchClick}
                        disabled={searching}
                    >
                        {searching ? 'Searching' : 'Search'}
                    </button>
                </Modal.Footer>
                </form>
            </Modal>
        </>
    );
}

export default SearchPipelineRangeModal;
